import { Heading, Box, Divider } from '@chakra-ui/react'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import {
  StatusCodeDistribution,
  ErrorCodeDistribution,
  Top404Table,
} from '../../components/Analytics'
import type { AnalyticsAPIResponse } from '../../interfaces'
import { UserContext } from '../../providers'

interface Props {
  data: AnalyticsAPIResponse | null
}

const ErrorReportsLayout = ({ data }: Props): React.ReactElement => {
  const { t } = useTranslation()
  const { user } = useContext(UserContext)

  const isUserOnImagekitCDN = user?.clientIsOnImageKitCDN

  if (!data) {
    return <span>{t('loading', 'Loading...')}</span>
  }

  return (
    <Box padding="1.5rem" marginBottom="2.5rem">
      {isUserOnImagekitCDN && (
        <Box>
          <Heading as="h4" size="md" textAlign="left" marginBottom="0.5rem">
            {t(
              'response_status_code_distribution',
              'Response Status Code Distribution',
            )}
          </Heading>
          <Divider />
          <StatusCodeDistribution {...{ data }} />
        </Box>
      )}
      {isUserOnImagekitCDN && (
        <Box marginTop="2.5rem">
          <Heading as="h4" size="md" textAlign="left" marginBottom="0.5rem">
            {t('error_reasons_404', '404 ERROR REASONS')}
          </Heading>
          <Divider />
          <ErrorCodeDistribution {...{ data }} />
        </Box>
      )}
      {isUserOnImagekitCDN && (
        <Box marginTop="2.5rem">
          <Heading as="h4" size="md" textAlign="left" marginBottom="0.5rem">
            {t('top_404_errors', 'Top 404 Errors')}
          </Heading>
          <Divider />
          <Top404Table {...{ data }} />
        </Box>
      )}
    </Box>
  )
}

export default ErrorReportsLayout
